<template>
	<template v-if="errors.message">
		<div class="alert alert-warning">
			{{ $t(errors.message) }}
		</div>
	</template>

	<template v-if="activation.message">
		<div class="alert" v-bind:class="{ 'alert-warning': !activation.passed, 'alert-success': activation.passed }">
			{{ $t(activation.message) }}
		</div>
	</template>

	<App.Form @submit="submit">
		<App.Input
			v-model="form.email"
			:error="errors.email"
		>
			E-mail
		</App.Input>

		<App.Input
			v-model="form.password"
			:error="errors.password"
			:type="'password'"
		>
			Hasło
		</App.Input>

		<div class="flex flex-space-between flex-align-center">
			<router-link :to="{ name: 'passwordResetStepOne' }" class="text-thin">
				<i class="fas fa-unlock-alt f-3 m-r-2"></i>

				Zapomniałem hasła
			</router-link>

			<App.Button :loading="loadings.login">
				Zaloguj się
			</App.Button>
		</div>
	</App.Form>
</template>

<script setup>
	import * as App from './../components'
	import { useStore } from 'vuex'
	import { useRoute, useRouter } from 'vue-router'
	import { ref, getCurrentInstance, onMounted, computed } from 'vue'

	const store = useStore()
	const route = useRoute()
	const router = useRouter()
	const context = getCurrentInstance()

	const form = ref({})

	const activation = computed(() => store.state.activation)

	const submit = () => {
		store.dispatch('login', {
			payload: form,
			context,
			loading: 'login'
		}).then(() => {
			let params = new URLSearchParams(window.location.search)
			window.location.href = !params.get('ref') ? process.env.MIX_APP_BASE_URL + '/app/' : process.env.MIX_APP_BASE_URL + params.get('ref')
		})
	}

	const activate = () => {
		store.dispatch('activate', route.params.code).then(() => {
			router.replace({ name: 'login' })
		})
	}

	onMounted(() => {
		if (route.params.code) {
			activate()
		}
	})
</script>
